/**
 * Coure.Hub.PartnerContentService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllPartnerContentResponseDto } from '../model/allPartnerContentResponseDto';
import { ContentRetrivalTypeEnum } from '../model/contentRetrivalTypeEnum';
import { ContentType } from '../model/contentType';
import { CreatePartnerContentImgResponseDto } from '../model/createPartnerContentImgResponseDto';
import { CreatePartnerContentRequestDto } from '../model/createPartnerContentRequestDto';
import { CreatePartnerContentRequestWithoutFileDto } from '../model/createPartnerContentRequestWithoutFileDto';
import { GetPartnerContentFileDto } from '../model/getPartnerContentFileDto';
import { HubPartnerContentTbl } from '../model/hubPartnerContentTbl';
import { PartnerContentResponseDto } from '../model/partnerContentResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PartnerContentService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param partnerId 
     * @param contentName 
     * @param retrievalType 
     * @param category 
     * @param uRLMethod 
     * @param systemRouteId 
     * @param contentType 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentCreatePartnerContentPostForm(partnerId?: string, contentName?: string, retrievalType?: ContentRetrivalTypeEnum, category?: string, uRLMethod?: string, systemRouteId?: string, contentType?: ContentType, file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiPartnerContentCreatePartnerContentPostForm(partnerId?: string, contentName?: string, retrievalType?: ContentRetrivalTypeEnum, category?: string, uRLMethod?: string, systemRouteId?: string, contentType?: ContentType, file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiPartnerContentCreatePartnerContentPostForm(partnerId?: string, contentName?: string, retrievalType?: ContentRetrivalTypeEnum, category?: string, uRLMethod?: string, systemRouteId?: string, contentType?: ContentType, file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiPartnerContentCreatePartnerContentPostForm(partnerId?: string, contentName?: string, retrievalType?: ContentRetrivalTypeEnum, category?: string, uRLMethod?: string, systemRouteId?: string, contentType?: ContentType, file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (partnerId !== undefined) {
            formParams = formParams.append('PartnerId', <any>partnerId) as any || formParams;
        }
        if (contentName !== undefined) {
            formParams = formParams.append('ContentName', <any>contentName) as any || formParams;
        }
        if (retrievalType !== undefined) {
            formParams = formParams.append('RetrievalType', <any>retrievalType) as any || formParams;
        }
        if (category !== undefined) {
            formParams = formParams.append('Category', <any>category) as any || formParams;
        }
        if (uRLMethod !== undefined) {
            formParams = formParams.append('URLMethod', <any>uRLMethod) as any || formParams;
        }
        if (systemRouteId !== undefined) {
            formParams = formParams.append('SystemRouteId', <any>systemRouteId) as any || formParams;
        }
        if (contentType !== undefined) {
            formParams = formParams.append('ContentType', <any>contentType) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) as any || formParams;
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/PartnerContent/createPartnerContent`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentCreatePartnerContentWithoutFilePost(body?: CreatePartnerContentRequestWithoutFileDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiPartnerContentCreatePartnerContentWithoutFilePost(body?: CreatePartnerContentRequestWithoutFileDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiPartnerContentCreatePartnerContentWithoutFilePost(body?: CreatePartnerContentRequestWithoutFileDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiPartnerContentCreatePartnerContentWithoutFilePost(body?: CreatePartnerContentRequestWithoutFileDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/PartnerContent/createPartnerContentWithoutFile`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentDeleteParterContentPartnerIdDelete(partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentResponseDto>;
    public apiPartnerContentDeleteParterContentPartnerIdDelete(partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentResponseDto>>;
    public apiPartnerContentDeleteParterContentPartnerIdDelete(partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentResponseDto>>;
    public apiPartnerContentDeleteParterContentPartnerIdDelete(partnerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling apiPartnerContentDeleteParterContentPartnerIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PartnerContentResponseDto>('delete',`${this.basePath}/api/PartnerContent/deleteParterContent/${encodeURIComponent(String(partnerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentGetAllPartnerContentGet(skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<AllPartnerContentResponseDto>;
    public apiPartnerContentGetAllPartnerContentGet(skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllPartnerContentResponseDto>>;
    public apiPartnerContentGetAllPartnerContentGet(skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllPartnerContentResponseDto>>;
    public apiPartnerContentGetAllPartnerContentGet(skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllPartnerContentResponseDto>('get',`${this.basePath}/api/PartnerContent/getAllPartnerContent`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentGetPartnerContentByIdGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<HubPartnerContentTbl>;
    public apiPartnerContentGetPartnerContentByIdGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubPartnerContentTbl>>;
    public apiPartnerContentGetPartnerContentByIdGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubPartnerContentTbl>>;
    public apiPartnerContentGetPartnerContentByIdGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<HubPartnerContentTbl>('get',`${this.basePath}/api/PartnerContent/getPartnerContentById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentGetPartnerContentByIdIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentResponseDto>;
    public apiPartnerContentGetPartnerContentByIdIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentResponseDto>>;
    public apiPartnerContentGetPartnerContentByIdIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentResponseDto>>;
    public apiPartnerContentGetPartnerContentByIdIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiPartnerContentGetPartnerContentByIdIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PartnerContentResponseDto>('get',`${this.basePath}/api/PartnerContent/getPartnerContentById/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentGetPartnerContentByPartnerIdPartnerIdGet(partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<AllPartnerContentResponseDto>;
    public apiPartnerContentGetPartnerContentByPartnerIdPartnerIdGet(partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllPartnerContentResponseDto>>;
    public apiPartnerContentGetPartnerContentByPartnerIdPartnerIdGet(partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllPartnerContentResponseDto>>;
    public apiPartnerContentGetPartnerContentByPartnerIdPartnerIdGet(partnerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling apiPartnerContentGetPartnerContentByPartnerIdPartnerIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllPartnerContentResponseDto>('get',`${this.basePath}/api/PartnerContent/getPartnerContentByPartnerId/${encodeURIComponent(String(partnerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentMapApiRetrivalPost(body?: CreatePartnerContentRequestDto, observe?: 'body', reportProgress?: boolean): Observable<PartnerContentResponseDto>;
    public apiPartnerContentMapApiRetrivalPost(body?: CreatePartnerContentRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PartnerContentResponseDto>>;
    public apiPartnerContentMapApiRetrivalPost(body?: CreatePartnerContentRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PartnerContentResponseDto>>;
    public apiPartnerContentMapApiRetrivalPost(body?: CreatePartnerContentRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PartnerContentResponseDto>('post',`${this.basePath}/api/PartnerContent/MapApiRetrival`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentPartnerContentFileByFilePathPost(body?: GetPartnerContentFileDto, observe?: 'body', reportProgress?: boolean): Observable<CreatePartnerContentImgResponseDto>;
    public apiPartnerContentPartnerContentFileByFilePathPost(body?: GetPartnerContentFileDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreatePartnerContentImgResponseDto>>;
    public apiPartnerContentPartnerContentFileByFilePathPost(body?: GetPartnerContentFileDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreatePartnerContentImgResponseDto>>;
    public apiPartnerContentPartnerContentFileByFilePathPost(body?: GetPartnerContentFileDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreatePartnerContentImgResponseDto>('post',`${this.basePath}/api/PartnerContent/PartnerContentFileByFilePath`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnerContentUploadPartnerContentImgPostForm(file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<CreatePartnerContentImgResponseDto>;
    public apiPartnerContentUploadPartnerContentImgPostForm(file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreatePartnerContentImgResponseDto>>;
    public apiPartnerContentUploadPartnerContentImgPostForm(file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreatePartnerContentImgResponseDto>>;
    public apiPartnerContentUploadPartnerContentImgPostForm(file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) as any || formParams;
        }

        return this.httpClient.request<CreatePartnerContentImgResponseDto>('post',`${this.basePath}/api/PartnerContent/UploadPartnerContentImg`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
